import React, { useEffect, useState } from "react";
import { Row, Col, Pagination } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import BackArrow from "../backArrow";
import { images } from "../../constants/index";
import { getAsset } from "../../helpers/helper";
import noImagePlaceholder from "../../assets/images/dummy/no_image_placeholder.png";
import dummyezi from "../../assets/images/dummy/dummyezi.png";
import "./availibleCandidates.css";

const Avaliablecandidate = ({ employeedata, mobileBackArrow = false }) => {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const safeData = Array.isArray(employeedata) ? employeedata : [];
  const minItems = 100;
  const itemsPerPage = 10;
  const effectiveData =
    safeData.length < minItems
      ? [
          ...safeData.map((item) => ({ type: "real", data: item })),
          ...Array(minItems - safeData.length).fill({ type: "dummy" }),
        ]
      : safeData.map((item) => ({ type: "real", data: item }));
  const totalPages = Math.ceil(effectiveData.length / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [employeedata]);

  const renderItems = () => {
    const firstIndex = (currentPage - 1) * itemsPerPage;
    const lastIndex = firstIndex + itemsPerPage;
    const currentDisplay = effectiveData.slice(firstIndex, lastIndex);

    return (
      <Row className="ps-2 pe-2">
        {currentDisplay.map((item, idx) => {
            if (item.type === "dummy") {
              return (
                <Col
                  key={`dummy-${idx}`}
                  xs={6}
                  sm={6}
                  md={6}
                  lg={4}
                  xl={3}
                  className="px-2 mt-3 d-flex justify-content-center"
                >
                  <div
                    className="card text-center cardsettingsss candidate-card"
                    style={{
                      overflow: "visible",
                      boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.2)",
                    }}
                  >
                    <img
                      src={dummyezi}
                      alt="Selectezi"
                      className="card-img-top img-fluid"
                      style={{
                        width: "100%",
                        aspectRatio: "4 / 3",
                        objectFit: "cover",
                        maxHeight: "160px",
                      }}
                    />

                    <div
                      className="card-body p-1 d-flex align-items-center justify-content-center"
                      style={{ height: "80px" }}
                    >
                      <p
                        className="mb-0"
                        style={{ color: "#0353A4", fontSize: "0.9rem" }}
                      >
                        Explore with Selectezi
                      </p>
                    </div>
                  </div>
                </Col>
              );
            }

            const e = item.data;
            return (
              <Col
                key={e?._id}
                xs={6}
                sm={6}
                md={6}
                lg={4}
                xl={3}
                className="px-2 mt-3 d-flex justify-content-center"
              >
                <div
                  className="card text-center cardsettingsss candidate-card"
                  style={{
                    overflow: "visible",
                    boxShadow: "0px 0px 5px 1px rgba(0,0,0,0.2)",
                  }}
                >
                  <img
                    className="card-img-top img--card img-fluid"
                    crossOrigin="anonymous"
                    src={
                      e?.image && e?.image?.length > 0
                        ? getAsset(e?.image)
                        : noImagePlaceholder
                    }
                    onError={(event) => {
                      event.target.onerror = null;
                      event.target.src = noImagePlaceholder;
                    }}
                    alt="Card cap"
                    style={{
                      width: "100%",
                      aspectRatio: "4 / 3",
                      objectFit: "cover",
                      maxHeight: "160px",
                    }}
                  />

                  <div className="card-body p-1 mt-2">
                    <h5
                      className="card-title mb-1"
                      style={{ fontSize: "0.9rem" }}
                    >
                      {e?.name || "Candidate Name"}
                    </h5>

                    <button
                      className="follow-connt mb-0" // ✅ reduced margin
                      onClick={() =>
                        navigate(`/view-buy-application/${e?._id}`)
                      }
                    >
                      View
                    </button>
                  </div>

                  {/* MESSAGE / CALL — UNCHANGED */}
                  <div
                    className="margin-Boxes"
                    style={{ paddingTop: "4px" }} // ✅ reduced spacing
                  >
                    <Row className="row bg-blue">
                      <Col lg={6} md={6} sm={6} xs={6} className="p-0">
                        <div className="border-end cursor">
                          <p className="mb-0 ps-1 d-flex p-1">
                            <img
                              className="Model_btn"
                              src={images.BlueMail}
                              alt="Mail icon"
                              style={{ width: "1rem", height: "1rem" }}
                            />
                            <span
                              className="btns text-white ps-1"
                              style={{ fontSize: "0.7rem" }}
                            >
                              Message
                            </span>
                          </p>
                        </div>
                      </Col>

                      <Col lg={6} md={6} sm={6} xs={6} className="p-0">
                        <div className="cursor">
                          <p className="mb-0 ps-1 d-flex p-1">
                            <img
                              className="Model_btn"
                              src={images.BluePhone}
                              alt="Phone icon"
                              style={{ width: "1rem", height: "1rem" }}
                            />
                            <span
                              className="btns text-white ps-1"
                              style={{ fontSize: "0.7rem" }}
                            >
                              Call
                            </span>
                          </p>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Col>
            );
        })}
      </Row>
    );
  };

  const renderPagination = () =>
    totalPages > 1 && (
      <div className="available-candidates-pagination">
        <div className="candidate-pagination-mobile justify-content-center">
          <Pagination className="candidate-pagination">
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            />
            <Pagination.Item disabled>
              {currentPage} / {totalPages}
            </Pagination.Item>
            <Pagination.Next
              disabled={currentPage === totalPages}
              onClick={() => setCurrentPage(currentPage + 1)}
            />
          </Pagination>
        </div>
        <div className="candidate-pagination-desktop justify-content-center">
          <Pagination>
            <Pagination.Prev
              disabled={currentPage === 1}
              onClick={() => setCurrentPage(currentPage - 1)}
            />
              {(() => {
                let items = [];

                if (totalPages <= 7) {
                  for (let i = 1; i <= totalPages; i++) {
                    items.push(
                      <Pagination.Item
                        key={i}
                        active={currentPage === i}
                        onClick={() => setCurrentPage(i)}
                      >
                        {i}
                      </Pagination.Item>
                    );
                  }
                } else {
                  if (currentPage <= 4) {
                    for (let i = 1; i <= 5; i++) {
                      items.push(
                        <Pagination.Item
                          key={i}
                          active={currentPage === i}
                          onClick={() => setCurrentPage(i)}
                        >
                          {i}
                        </Pagination.Item>
                      );
                    }
                    items.push(<Pagination.Ellipsis key="ellipsis" disabled />);
                    items.push(
                      <Pagination.Item
                        key={totalPages}
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </Pagination.Item>
                    );
                  } else if (currentPage > totalPages - 4) {
                    items.push(
                      <Pagination.Item key={1} onClick={() => setCurrentPage(1)}>
                        1
                      </Pagination.Item>
                    );
                    items.push(<Pagination.Ellipsis key="ellipsis" disabled />);
                    for (let i = totalPages - 4; i <= totalPages; i++) {
                      items.push(
                        <Pagination.Item
                          key={i}
                          active={currentPage === i}
                          onClick={() => setCurrentPage(i)}
                        >
                          {i}
                        </Pagination.Item>
                      );
                    }
                  } else {
                    items.push(
                      <Pagination.Item key={1} onClick={() => setCurrentPage(1)}>
                        1
                      </Pagination.Item>
                    );
                    items.push(<Pagination.Ellipsis key="ellipsis1" disabled />);
                    for (let i = currentPage - 1; i <= currentPage + 1; i++) {
                      items.push(
                        <Pagination.Item
                          key={i}
                          active={currentPage === i}
                          onClick={() => setCurrentPage(i)}
                        >
                          {i}
                        </Pagination.Item>
                      );
                    }
                    items.push(<Pagination.Ellipsis key="ellipsis2" disabled />);
                    items.push(
                      <Pagination.Item
                        key={totalPages}
                        onClick={() => setCurrentPage(totalPages)}
                      >
                        {totalPages}
                      </Pagination.Item>
                    );
                  }
                }
                return items;
              })()}
                <Pagination.Next
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                />
          </Pagination>
        </div>
      </div>
    );

  return (
    <div className="available-candidates-content col-12 col-sm-12 col-md-11 col-lg-11 col-xl-11 mx-auto mt-2">
      {!mobileBackArrow && <BackArrow back="/BuyingSide" />}
      {mobileBackArrow && <BackArrow back="/BuyingSide" mystyle="d-none d-lg-block" />}

      <h6 className="pt-1 mb-1" style={{ color: "blue", fontSize: "1rem" }}>
        Available Candidates
      </h6>

      <p className="ms-3" style={{ fontSize: "0.9rem" }}>
        250
      </p>

      <div className="available-candidates-scroll">
        {renderItems()}
      </div>
      {renderPagination()}
    </div>
  );
};

export default Avaliablecandidate;
